import BrandEntity from "../../../domain/entities/BrandEntity";

const fromJson = (brand: any): BrandEntity => {
    const lowerCaseName = brand.brand ? String(brand.brand).toLowerCase() : "";

    const capitalizedName = lowerCaseName ? lowerCaseName.charAt(0).toUpperCase() + lowerCaseName.slice(1) : "";
    return {
        id: brand.id,
        name: capitalizedName,
        image: brand.image,
    };
};

const toJson = (brand: BrandEntity): any => {
    return {
        id: brand.id,
        brand: brand.name,
        image: brand.image,
    };
};

export default {
    fromJson,
    toJson,
};
